module.exports = __webpack_public_path__ + "img/logo_dbm.1ef7ff7f.webp";